import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-promise-request',
  templateUrl: './promise-request.component.html',
  styleUrls: ['./promise-request.component.scss']
})
export class PromiseRequestComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
